import { render, staticRenderFns } from "./recommendGoods.vue?vue&type=template&id=941a973e&scoped=true&"
import script from "./recommendGoods.vue?vue&type=script&lang=js&"
export * from "./recommendGoods.vue?vue&type=script&lang=js&"
import style0 from "./recommendGoods.vue?vue&type=style&index=0&id=941a973e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "941a973e",
  null
  
)

export default component.exports